import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-environments-list-toolbar',
  templateUrl: './list-toolbar.environment.component.html',
  styleUrls: ['./list-toolbar.environment.component.scss'],
})
export class EnvironmentListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
